import { Link } from "react-router-dom";

const HowToPlanAStressFreeGroupJourney = () => {
    return (
        <section className="bg-primary">
            <div className="max-w-7xl mx-auto px-4">
                <div className="py-20 md:py-28">

                    <div className="text-center">

                        <p className="text-white/70 text-sm uppercase tracking-widest">
                            Travel Tips
                        </p>

                        <h1 className="mt-4 text-white text-4xl md:text-6xl font-bold max-w-5xl mx-auto leading-tight">
                            How To Plan A Stress-Free Group Journey
                        </h1>

                        <div className="mt-8 flex flex-wrap justify-center gap-4 text-white/70">
                            <span>June 20, 2026</span>
                            <span>•</span>
                            <span>Velox Charter</span>
                        </div>

                    </div>

                </div>
            </div>

            <section className="bg-[#F9FAFB] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="grid lg:grid-cols-12 gap-10">

                        <div className="lg:col-span-8">

                            <div className="bg-white rounded-[30px] overflow-hidden shadow-sm">

                                <img
                                    src="/images/group-journey.png"
                                    alt="Stress Free Group Journey"
                                    className="w-full h-[300px] md:h-[500px] object-cover"
                                />

                                <div className="p-8 md:p-12">

                                    <p className="text-[#666666] leading-8 text-lg">
                                        Planning transportation for a group can
                                        quickly become overwhelming without the
                                        right preparation. Coordinating schedules,
                                        selecting the right vehicle, managing
                                        luggage, and ensuring everyone arrives on
                                        time requires careful organization.
                                    </p>

                                    <p className="mt-6 text-[#666666] leading-8 text-lg">
                                        Whether you're organizing a corporate
                                        retreat, family reunion, wedding,
                                        sporting event, school trip, or private
                                        group outing, following a structured
                                        planning process can help create a smooth
                                        and stress-free travel experience for
                                        everyone involved.
                                    </p>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            1. Start Planning Early
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            One of the most effective ways to
                                            reduce travel stress is to begin
                                            planning as early as possible. Early
                                            preparation gives you more vehicle
                                            options, better scheduling
                                            flexibility, and time to address
                                            unexpected changes.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Secure Transportation Availability</li>
                                            <li>✓ Compare Vehicle Options</li>
                                            <li>✓ Coordinate Passenger Schedules</li>
                                            <li>✓ Avoid Last-Minute Issues</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            2. Confirm Your Passenger Count
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Knowing exactly how many people are
                                            traveling is essential when selecting
                                            transportation. Choosing the right
                                            vehicle ensures every passenger has
                                            enough space while helping manage
                                            transportation costs.
                                        </p>

                                        <div className="grid sm:grid-cols-2 gap-4 mt-6">
                                            {[
                                                "Executive Sedans",
                                                "Luxury SUVs",
                                                "Sprinter Vans",
                                                "Charter Buses",
                                            ].map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="bg-[#F8FAFC] border rounded-[16px] p-5"
                                                >
                                                    {item}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            3. Create A Detailed Itinerary
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            A detailed itinerary helps keep
                                            everyone informed and minimizes
                                            confusion throughout the trip.
                                            Include pickup times, departure
                                            locations, destinations, contact
                                            information, and any scheduled stops.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            4. Consider Luggage Requirements
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Group travel often involves luggage,
                                            equipment, or personal belongings.
                                            Make sure the selected vehicle has
                                            sufficient storage space to
                                            accommodate passengers comfortably.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            This is particularly important for
                                            airport transfers, multi-day trips,
                                            conferences, and sporting events.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            5. Prioritize Passenger Comfort
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Comfortable passengers enjoy the
                                            journey more. Consider vehicle
                                            amenities such as spacious seating,
                                            climate control, charging ports,
                                            luggage storage, and premium
                                            interiors.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Comfortable Seating</li>
                                            <li>✓ Climate-Controlled Interiors</li>
                                            <li>✓ Charging Ports</li>
                                            <li>✓ Spacious Legroom</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            6. Work With A Professional Transportation Provider
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Partnering with an experienced
                                            transportation company helps
                                            eliminate many of the challenges
                                            associated with group travel.
                                            Professional providers handle route
                                            planning, scheduling, logistics, and
                                            driver coordination.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            7. Communicate Clearly With Travelers
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Clear communication is one of the
                                            most important elements of successful
                                            group travel. Share itineraries,
                                            pickup instructions, emergency
                                            contacts, and travel expectations
                                            well before departure.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            8. Prepare For Unexpected Changes
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Traffic conditions, weather delays,
                                            flight changes, and schedule updates
                                            can occur unexpectedly. Building
                                            flexibility into your plans helps
                                            reduce stress when adjustments become
                                            necessary.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            Final Thoughts
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            A successful group journey begins
                                            with thoughtful planning. By
                                            organizing transportation early,
                                            choosing the right vehicle,
                                            prioritizing comfort, and working
                                            with experienced transportation
                                            professionals, you can create a
                                            seamless travel experience from start
                                            to finish.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Whether you're coordinating a
                                            corporate event, wedding, airport
                                            transfer, or private group trip, Velox
                                            Charter is committed to helping you
                                            travel safely, comfortably, and
                                            stress-free.
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="lg:col-span-4">

                            <div className="sticky top-6">

                                <div className="bg-primary rounded-[24px] p-8 text-center">

                                    <h3 className="text-white text-2xl font-semibold">
                                        Planning A Group Trip?
                                    </h3>

                                    <p className="mt-4 text-white/80 leading-7">
                                        Let our transportation specialists help
                                        coordinate the perfect travel solution
                                        for your group.
                                    </p>

                                    <Link
                                        to="/contact-us"
                                        className="mt-4 inline-block bg-white text-primary px-8 py-4 rounded-full font-semibold hover:scale-105 transition-all"
                                    >
                                        Contact Us
                                    </Link>

                                </div>

                                <div className="bg-white rounded-[24px] p-8 mt-8">

                                    <h3 className="text-2xl font-semibold">
                                        Group Travel Essentials
                                    </h3>

                                    <div className="mt-6 space-y-4 text-[#666666]">
                                        <p>✓ Confirm Passenger Count</p>
                                        <p>✓ Create A Travel Itinerary</p>
                                        <p>✓ Plan Luggage Space</p>
                                        <p>✓ Book Transportation Early</p>
                                        <p>✓ Share Travel Information</p>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>

        </section>
    );
};

export default HowToPlanAStressFreeGroupJourney;